import { createRequest } from './createRequest'

export const gridGetPath = '/grid/get'
export const gridGet = createRequest({ path: gridGetPath })

export const gridSavePath = '/grid/save'
export const gridSave = createRequest({ path: gridSavePath })

export const gridPublishPath = '/grid/publish'
export const gridPublish = createRequest({ path: gridPublishPath })

export const gridListPath = '/grid/list'
export const gridList = createRequest({ path: gridListPath })

export const gridEditPath = '/grid/edit'
export const gridEdit = createRequest({ path: gridEditPath })

export const gridDeletePath = '/grid/delete'
export const gridDelete = createRequest({ path: gridDeletePath })
